import { createContext, useContext } from 'react';

import type {
  EncryptedPrivateKey,
  PrivateKeyRecovery,
  Wallet,
} from '@sorare/wallet-shared';

export interface UpdateUserAttributes {
  email?: string;
  passwordHash?: string;
  currentPasswordHash?: string;
  sorarePrivateKey?: EncryptedPrivateKey;
  nickname?: string;
  sorareAddress?: string;
  sorarePrivateKeyBackup?: string;
  starkKey?: string;
  recaptchaToken?: string;
  recaptchaTokenV2?: string;
  wallet?: Wallet;
}

export interface UpdateUserEmailAttributes {
  email: string;
  recaptchaToken?: string;
  recaptchaTokenV2?: string;
  privateKeyRecovery?: PrivateKeyRecovery;
}

export type AuthResponse = {
  errors?: Record<string, string[]>;
  error?: string;
};

type AuthContext = {
  updateUser: (params: UpdateUserAttributes) => Promise<AuthResponse>;
  createResetPasswordRequest: (
    email: string,
    recaptchaToken: string
  ) => Promise<AuthResponse>;
  resetPassword: (password: string, token: string) => Promise<AuthResponse>;
};

export const AuthContext = createContext<AuthContext | null>(null);

export const useAuthContext = () => useContext(AuthContext)!;
